/* eslint-disable react-perf/jsx-no-new-object-as-prop */
import cn from 'classnames'
import { useSpring, animated } from 'react-spring'

import styles from './Loader.module.scss'
import { config, COORDINATES } from './utils'

import Orbit from '~icons/illustrations/orbit.svg'
import Planet from '~icons/illustrations/planet2.svg'
import Saturn from '~icons/illustrations/saturn.svg'

export interface LoaderProps {
  size?: 'm' | 'l'
  text?: string
  className?: string
}

function Loader({ size = 'l', className = '', text }: LoaderProps) {
  const circleSpringStyle = useSpring({
    config,
    loop: true,
    from: COORDINATES.circle.from,
    to: COORDINATES.circle.to,
  })

  const planetSpringStyle = useSpring({
    config,
    loop: true,
    from: COORDINATES.planet[size].from,
    to: COORDINATES.planet[size].to,
  })

  const transparentPlanetsSpringStyle = useSpring({
    config,
    loop: true,
    from: COORDINATES.transparentPlanet[size].from,
    to: COORDINATES.transparentPlanet[size].to,
  })

  const saturnSpringStyle = useSpring({
    config,
    loop: true,
    from: COORDINATES.saturn[size].from,
    to: COORDINATES.saturn[size].to,
  })

  const numSpringStyle = useSpring({
    config,
    loop: true,
    from: COORDINATES.text.from,
    to: COORDINATES.text.to,
  })

  return (
    <div
      className={cn(styles.root, styles[size], className)}
      style={size === 'm' ? { height: '100px', width: '100px' } : { height: '150px', width: '150px' }}
    >
      <animated.span style={{ position: 'absolute', zIndex: 1, ...saturnSpringStyle }} className={styles.saturn}>
        <Saturn />
      </animated.span>

      <animated.span style={{ position: 'absolute', zIndex: 1, ...planetSpringStyle }} className={styles.planet}>
        <Planet />
      </animated.span>

      <animated.span
        style={{
          position: 'absolute',
          zIndex: 1,
          opacity: 0.5,
          ...transparentPlanetsSpringStyle,
        }}
        className={styles.transparentPlanet}
      >
        <Planet />
      </animated.span>

      <animated.span style={{ ...circleSpringStyle }} className={styles.circle}>
        <Orbit />
      </animated.span>

      <span className={styles.text}>
        {text || 'Loading'}
        <animated.span>
          {numSpringStyle.num.to((v) => {
            // eslint-disable-next-line unicorn/no-new-array
            return new Array(Math.round(v)).fill('.').join('')
          })}
        </animated.span>
      </span>
    </div>
  )
}

export default Loader
